/* IWI Trade Tools — Staff training (Level 1)
   Hash routes: #/ · #/track/<id> · #/m/<id> · #/m/<id>/quiz · #/exam · #/certificate · #/continue
   Progress: localStorage "iwi_tt_training_v1" (per browser). Content: assets/iwi-tt-training-data.json */
(function () {
  'use strict';
  var root = document.querySelector('[data-iwi-trn]');
  if (!root) return;
  var app = root.querySelector('[data-trn-app]');
  var KEY = 'iwi_tt_training_v1';
  var D = null, MOD = {}, PRODS = {}, quiz = null;

  /* ---------- storage ---------- */
  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); if (v && v.v === 1) return v; } catch (e) {}
    return { v: 1, name: '', venue: '', modules: {}, exam: null, last: '' };
  }
  var ST = load();
  function save() { try { localStorage.setItem(KEY, JSON.stringify(ST)); } catch (e) {} }

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function pct(n, d) { return d ? Math.round((n / d) * 100) : 0; }
  function mods(track) { return D.modules.filter(function (m) { return m.track === track; }); }
  function status(m) { var r = ST.modules[m.id]; if (!r) return 'new'; return r.passed ? 'passed' : 'tried'; }
  function passedCount(list) { return list.filter(function (m) { return status(m) === 'passed'; }).length; }
  function trackOf(id) { return D.tracks.filter(function (t) { return t.id === id; })[0]; }
  function fmtDate(ts) { try { return new Date(ts).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return ''; } }
  function icon(name) {
    var p = {
      check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>', x: '<path d="M6 6l12 12M18 6L6 18"/>',
      arrow: '<path d="M5 12h14M13.5 6.5L19 12l-5.5 5.5"/>', back: '<path d="M19 12H5M10.5 6.5L5 12l5.5 5.5"/>',
      ext: '<path d="M14 4.5h5.5V10M19.5 4.5L11 13M18 14v5.5H4.5V6H10"/>', lock: '<rect x="5.5" y="10.5" width="13" height="10" rx="1"/><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5"/>',
      print: '<path d="M7 9V3.5h10V9M7 17.5H4.5V9h15v8.5H17"/><rect x="7" y="14" width="10" height="6.5"/>',
      clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>', retry: '<path d="M4.5 12a7.5 7.5 0 1 0 2.2-5.3M4.5 4.5v4h4"/>',
      search: '<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>', star: '<path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.8l-5.2 2.8 1-5.8-4.3-4.1 5.9-.8z"/>'
    }[name] || '';
    return '<svg class="iwi-trn-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }
  function srcLink(s) {
    if (!s) return '';
    return s.url ? '<a href="' + esc(s.url) + '" target="_blank" rel="noopener">' + esc(s.label) + ' ' + icon('ext') + '</a>' : '<span>' + esc(s.label) + '</span>';
  }

  /* ---------- progress / hero ---------- */
  function core() { return mods('foundations').concat(mods('italy')); }
  function eligible() {
    var c = core();
    return passedCount(c) === c.length && ST.exam && ST.exam.passed;
  }
  function updateHero() {
    var all = D.modules, done = passedCount(all), c = core(), cd = passedCount(c);
    var p = pct(cd + (ST.exam && ST.exam.passed ? 1 : 0), c.length + 1);
    var bar = root.querySelector('[data-trn-bar]');
    if (bar) { bar.setAttribute('aria-valuenow', p); bar.querySelector('.iwi-trn-bar__fill').style.width = p + '%'; }
    var st = root.querySelector('[data-trn-stats]');
    var nq = all.reduce(function (a, m) { return a + m.quiz.length; }, 0);
    if (st) st.innerHTML = '<strong>' + p + '%</strong> of Level 1 · ' + cd + '/' + c.length + ' core modules · ' + done + '/' + all.length + ' modules passed overall · ' + nq + ' questions' +
      (ST.exam ? ' · final exam best ' + ST.exam.best + '%' : '');
    var cont = root.querySelector('[data-trn-continue]');
    if (cont) cont.textContent = (done || ST.exam) ? 'Continue' : 'Start Level 1';
  }

  /* ---------- views ---------- */
  function card(m) {
    var r = ST.modules[m.id], s = status(m);
    var badge = s === 'passed' ? '<span class="iwi-trn-badge is-pass">' + icon('check') + ' ' + r.best + '%</span>'
      : s === 'tried' ? '<span class="iwi-trn-badge is-try">Best ' + r.best + '%</span>' : '<span class="iwi-trn-badge">' + m.quiz.length + ' questions</span>';
    var logo = '';
    if (m.track === 'producers') { var p = PRODS[m.handle]; if (p && p.logo) logo = '<img class="iwi-trn-card__logo" src="' + esc(p.logo) + '" alt="" loading="lazy" width="120" height="60">'; }
    return '<li class="iwi-trn-card is-' + s + '" data-s="' + esc((m.title + ' ' + (m.region || '') + ' ' + (m.summary || '')).toLowerCase()) + '" data-r="' + esc(m.region || '') + '">' +
      '<a class="iwi-trn-card__in" href="#/m/' + m.id + '">' +
      '<span class="iwi-trn-card__num">' + (m.track === 'producers' ? '' : String(m.n).padStart(2, '0')) + '</span>' + logo +
      '<span class="iwi-trn-card__lvl">' + esc(m.level) + (m.region && m.track !== 'producers' ? ' · ' + esc(m.region) : '') + '</span>' +
      '<span class="iwi-trn-card__title">' + esc(m.title) + '</span>' +
      '<span class="iwi-trn-card__sum">' + esc(m.summary || '') + '</span>' +
      '<span class="iwi-trn-card__foot">' + badge + '<span class="iwi-trn-card__min">' + icon('clock') + m.minutes + ' min</span></span>' +
      '</a></li>';
  }
  function trackBlock(t) {
    var list = mods(t.id), done = passedCount(list);
    var tools = '';
    if (t.id === 'producers') {
      var regions = []; list.forEach(function (m) { if (m.region && regions.indexOf(m.region) < 0) regions.push(m.region); });
      tools = '<div class="iwi-trn-tools"><label class="iwi-trn-search">' + icon('search') + '<span class="visually-hidden">Search producers</span><input type="search" placeholder="Producer, town, region…" data-trn-psearch></label>' +
        '<div class="iwi-trn-chips" role="group" aria-label="Region"><button type="button" class="iwi-trn-chip is-on" data-trn-region="">All</button>' +
        regions.sort().map(function (r) { return '<button type="button" class="iwi-trn-chip" data-trn-region="' + esc(r) + '">' + esc(r) + '</button>'; }).join('') + '</div></div>';
    }
    return '<section class="iwi-trn-track" id="trn-' + t.id + '" aria-labelledby="trn-h-' + t.id + '">' +
      '<div class="iwi-trn-track__head"><span class="iwi-trn-track__n">' + t.n + '</span><div><h2 class="iwi-trn-h2" id="trn-h-' + t.id + '">' + esc(t.title) + '</h2><p class="iwi-trn-track__blurb">' + esc(t.blurb) + '</p></div>' +
      '<div class="iwi-trn-track__meter"><span>' + done + ' / ' + list.length + ' passed</span><span class="iwi-trn-mini"><span style="width:' + pct(done, list.length) + '%"></span></span></div></div>' +
      tools + '<ul class="iwi-trn-grid' + (t.id === 'producers' ? ' iwi-trn-grid--prod' : '') + '" role="list">' + list.map(card).join('') + '</ul>' +
      (t.id === 'producers' ? '<p class="iwi-trn-empty" hidden data-trn-pempty>No producer matches.</p>' : '') + '</section>';
  }
  function examBlock() {
    var e = ST.exam, el = eligible();
    var c = core(), cd = passedCount(c);
    return '<section class="iwi-trn-track iwi-trn-final" id="trn-final"><div class="iwi-trn-final__in">' +
      '<div><span class="iwi-trn-kicker iwi-trn-kicker--rust">Finish Level 1</span><h2 class="iwi-trn-h2">Final exam &amp; certificate</h2>' +
      '<p>' + D.exam_size + ' questions drawn at random from every track. Pass mark ' + D.pass_exam + '%. The certificate unlocks when all ' + c.length + ' Foundation and Italy modules are passed (' + D.pass_module + '%+) and the final exam is passed.</p>' +
      '<ul class="iwi-trn-check"><li class="' + (cd === c.length ? 'ok' : '') + '">' + icon(cd === c.length ? 'check' : 'lock') + ' Core modules ' + cd + '/' + c.length + '</li>' +
      '<li class="' + (e && e.passed ? 'ok' : '') + '">' + icon(e && e.passed ? 'check' : 'lock') + ' Final exam ' + (e ? 'best ' + e.best + '%' : 'not attempted') + '</li></ul></div>' +
      '<div class="iwi-trn-final__ctas"><a class="iwi-trn-btn iwi-trn-btn--solid" href="#/exam">' + (e ? 'Retake final exam' : 'Take the final exam') + '</a>' +
      '<a class="iwi-trn-btn" href="#/certificate">' + icon(el ? 'star' : 'lock') + (el ? ' View certificate' : ' Certificate (locked)') + '</a></div></div></section>';
  }
  function viewHome(focusTrack) {
    var html = '<nav class="iwi-trn-tabs" aria-label="Tracks">' + D.tracks.map(function (t) {
      return '<a href="#/track/' + t.id + '" class="iwi-trn-tab"><span>' + t.n + '</span>' + esc(t.title) + ' <em>' + passedCount(mods(t.id)) + '/' + mods(t.id).length + '</em></a>';
    }).join('') + '<a href="#/exam" class="iwi-trn-tab"><span>✦</span>Final exam</a></nav>';
    html += D.tracks.map(trackBlock).join('') + examBlock();
    html += '<p class="iwi-trn-reset"><button type="button" class="iwi-trn-link" data-trn-reset>Reset my progress on this device</button></p>';
    app.innerHTML = html;
    bindProducerFilter();
    var b = app.querySelector('[data-trn-reset]');
    if (b) b.addEventListener('click', function () {
      if (window.confirm('Clear all training progress saved in this browser?')) { ST = { v: 1, name: ST.name, venue: ST.venue, modules: {}, exam: null, last: '' }; save(); render(); }
    });
    if (focusTrack) { var el = document.getElementById('trn-' + focusTrack); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
  function bindProducerFilter() {
    var q = app.querySelector('[data-trn-psearch]'); if (!q) return;
    var region = '';
    function apply() {
      var t = q.value.trim().toLowerCase(), n = 0;
      app.querySelectorAll('.iwi-trn-grid--prod > li').forEach(function (li) {
        var ok = (!t || li.getAttribute('data-s').indexOf(t) > -1) && (!region || li.getAttribute('data-r') === region);
        li.hidden = !ok; if (ok) n++;
      });
      app.querySelector('[data-trn-pempty]').hidden = n > 0;
    }
    q.addEventListener('input', apply);
    app.querySelectorAll('[data-trn-region]').forEach(function (b) {
      b.addEventListener('click', function () {
        region = b.getAttribute('data-trn-region');
        app.querySelectorAll('[data-trn-region]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        apply();
      });
    });
  }

  function producerCards(handles) {
    var items = (handles || []).map(function (h) { return PRODS[h]; }).filter(Boolean);
    if (!items.length) return '';
    return '<aside class="iwi-trn-prods"><h3 class="iwi-trn-h3">Our producers here</h3><ul role="list">' + items.map(function (p) {
      var hasQuiz = MOD['p-' + p.h];
      return '<li><a href="' + (hasQuiz ? '#/m/p-' + p.h : esc(p.url || '#')) + '">' +
        (p.logo ? '<img src="' + esc(p.logo) + '" alt="" loading="lazy" width="96" height="48">' : '<span class="iwi-trn-prods__ph">' + esc(p.n.charAt(0)) + '</span>') +
        '<span><strong>' + esc(p.n) + '</strong><small>' + esc([p.t, p.r].filter(Boolean).join(' · ')) + '</small></span></a></li>';
    }).join('') + '</ul></aside>';
  }
  function producerBody(m) {
    var p = PRODS[m.handle] || {};
    var facts = [['Where', [p.t, p.r, p.c].filter(Boolean).join(' · ')], ['Founded', p.f], ['Vineyards', p.ha], ['Key grapes', p.g], ['Winemaker', p.w]]
      .filter(function (f) { return f[1]; });
    return (p.hero ? '<figure class="iwi-trn-phero"><img src="' + esc(p.hero) + '" alt="' + esc(p.n || m.title) + ' vineyards" loading="lazy"></figure>' : '') +
      '<div class="iwi-trn-pbody">' + (p.logo ? '<img class="iwi-trn-plogo" src="' + esc(p.logo) + '" alt="' + esc(m.title) + ' logo" width="160" height="80">' : '') +
      (p.s ? '<p class="iwi-trn-story">' + esc(p.s) + '</p>' : '') +
      '<dl class="iwi-trn-facts">' + facts.map(function (f) { return '<div><dt>' + f[0] + '</dt><dd>' + esc(f[1]) + '</dd></div>'; }).join('') + '</dl>' +
      '<h3 class="iwi-trn-h3">Wines in our range</h3><ul class="iwi-trn-wines">' + (m.wines || []).map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>' +
      '<p class="iwi-trn-links">' + (p.url ? '<a class="iwi-trn-btn" href="' + esc(p.url) + '">See the wines</a>' : '') +
      '<a class="iwi-trn-btn" href="' + esc(root.getAttribute('data-media-url')) + '?producer=' + esc(m.handle) + '">Producer kit</a>' +
      (p.web ? '<a class="iwi-trn-btn" href="' + esc(p.web) + '" target="_blank" rel="noopener">Producer website ' + icon('ext') + '</a>' : '') + '</p>' +
      '<p class="iwi-trn-note">Every question in this quiz comes from our own producer and wine records (each answer shows its source).</p></div>';
  }
  function viewModule(id) {
    var m = MOD[id]; if (!m) return viewHome();
    ST.last = id; save();
    var t = trackOf(m.track), r = ST.modules[m.id];
    var list = mods(m.track), i = list.indexOf(m), next = list[i + 1];
    var html = '<nav class="iwi-trn-crumbs" aria-label="Breadcrumb"><a href="#/">' + icon('back') + ' All modules</a><span>/</span><a href="#/track/' + t.id + '">' + esc(t.title) + '</a></nav>' +
      '<article class="iwi-trn-lesson"><header class="iwi-trn-lesson__head">' +
      '<span class="iwi-trn-kicker iwi-trn-kicker--rust">' + esc(t.title) + (m.track !== 'producers' ? ' · Module ' + m.n : '') + '</span>' +
      '<h2 class="iwi-trn-h1">' + esc(m.title) + '</h2><p class="iwi-trn-lede">' + esc(m.summary || '') + '</p>' +
      '<p class="iwi-trn-meta">' + icon('clock') + ' ' + m.minutes + ' min read · ' + m.quiz.length + ' questions · pass ' + D.pass_module + '%' +
      (r ? ' · <strong>' + (r.passed ? 'Passed' : 'Best') + ' ' + r.best + '%</strong>' : '') + '</p></header>' +
      '<div class="iwi-trn-lesson__grid"><div class="iwi-trn-rich">' + (m.track === 'producers' ? producerBody(m) : m.body) + '</div>' +
      '<div class="iwi-trn-side">' + (m.track !== 'producers' ? producerCards(m.producers) : '') +
      '<div class="iwi-trn-quizcta"><p><strong>Ready?</strong> ' + m.quiz.length + ' questions, instant feedback.</p><a class="iwi-trn-btn iwi-trn-btn--solid" href="#/m/' + m.id + '/quiz">' + (r ? 'Retake quiz' : 'Start quiz') + ' ' + icon('arrow') + '</a></div></div></div>' +
      '<footer class="iwi-trn-sources"><h3 class="iwi-trn-h3">Sources</h3><ol>' + (m.sources || []).map(function (s) { return '<li>' + srcLink(s) + '</li>'; }).join('') + '</ol>' +
      '<p class="iwi-trn-small">Written for IWI staff. General wine knowledge is checked against the sources above; producer facts come from our producer and wine records. Course structure inspired by public Level 2–style syllabi; no third-party course material is reproduced.</p></footer>' +
      (next ? '<a class="iwi-trn-next" href="#/m/' + next.id + '">Next: ' + esc(next.title) + ' ' + icon('arrow') + '</a>' : '') + '</article>';
    app.innerHTML = html;
    var h = app.querySelector('.iwi-trn-h1'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }

  /* ---------- quiz engine ---------- */
  function startQuiz(kind, m) {
    var qs;
    if (kind === 'exam') {
      var pick = function (track, n) { var pool = []; mods(track).forEach(function (mm) { mm.quiz.forEach(function (q) { pool.push(Object.assign({ mod: mm.title }, q)); }); }); return shuffle(pool).slice(0, n); };
      var n = D.exam_size;
      qs = shuffle([].concat(pick('foundations', Math.round(n * 0.3)), pick('italy', Math.round(n * 0.37)), pick('producers', Math.round(n * 0.17)), pick('selling', n - Math.round(n * 0.3) - Math.round(n * 0.37) - Math.round(n * 0.17))));
    } else {
      qs = shuffle(m.quiz.map(function (q) { return Object.assign({ mod: m.title }, q); }));
    }
    qs = qs.map(function (q) {
      var order = shuffle(q.options.map(function (_, i) { return i; }));
      return { q: q.q, options: order.map(function (i) { return q.options[i]; }), answer: order.indexOf(q.answer), explain: q.explain, source: q.source, mod: q.mod };
    });
    quiz = { kind: kind, m: m, qs: qs, i: 0, picks: [], score: 0 };
    renderQ();
  }
  function quizHead() {
    var title = quiz.kind === 'exam' ? 'Final exam' : quiz.m.title;
    var dots = quiz.qs.map(function (_, i) {
      var c = i < quiz.picks.length ? (quiz.picks[i] === quiz.qs[i].answer ? 'ok' : 'no') : (i === quiz.i ? 'cur' : '');
      return '<span class="' + c + '"></span>';
    }).join('');
    return '<nav class="iwi-trn-crumbs"><a href="' + (quiz.kind === 'exam' ? '#/' : '#/m/' + quiz.m.id) + '">' + icon('back') + ' ' + (quiz.kind === 'exam' ? 'All modules' : 'Back to lesson') + '</a></nav>' +
      '<div class="iwi-trn-qhead"><span class="iwi-trn-kicker iwi-trn-kicker--rust">' + esc(title) + '</span>' +
      '<div class="iwi-trn-dots" aria-hidden="true">' + dots + '</div>' +
      '<p class="iwi-trn-qcount">Question ' + Math.min(quiz.i + 1, quiz.qs.length) + ' of ' + quiz.qs.length + ' · score ' + quiz.score + '</p></div>';
  }
  function renderQ() {
    var q = quiz.qs[quiz.i];
    var html = '<div class="iwi-trn-quiz">' + quizHead() +
      '<div class="iwi-trn-qcard">' + (quiz.kind === 'exam' ? '<span class="iwi-trn-qfrom">' + esc(q.mod) + '</span>' : '') +
      '<h2 class="iwi-trn-q" id="trn-q" tabindex="-1">' + esc(q.q) + '</h2>' +
      '<div class="iwi-trn-opts" role="group" aria-labelledby="trn-q">' + q.options.map(function (o, i) {
        return '<button type="button" class="iwi-trn-opt" data-i="' + i + '"><span class="iwi-trn-opt__k">' + 'ABCD'.charAt(i) + '</span><span class="iwi-trn-opt__t">' + esc(o) + '</span></button>';
      }).join('') + '</div><div class="iwi-trn-feedback" data-trn-fb aria-live="assertive"></div></div>' +
      '<p class="iwi-trn-keys">Tip: press <kbd>1</kbd>–<kbd>' + q.options.length + '</kbd> to answer, <kbd>Enter</kbd> for next.</p></div>';
    app.innerHTML = html;
    app.querySelectorAll('.iwi-trn-opt').forEach(function (b) { b.addEventListener('click', function () { answer(+b.getAttribute('data-i')); }); });
    var h = document.getElementById('trn-q'); if (h) h.focus({ preventScroll: true });
    var top = app.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }
  function answer(i) {
    if (!quiz || quiz.picks.length > quiz.i) return;
    var q = quiz.qs[quiz.i], ok = i === q.answer;
    quiz.picks.push(i); if (ok) quiz.score++;
    app.querySelectorAll('.iwi-trn-opt').forEach(function (b, k) {
      b.disabled = true;
      if (k === q.answer) b.classList.add('is-right');
      if (k === i && !ok) b.classList.add('is-wrong');
      if (k === i) b.setAttribute('aria-pressed', 'true');
    });
    var last = quiz.i === quiz.qs.length - 1;
    var fb = app.querySelector('[data-trn-fb]');
    fb.className = 'iwi-trn-feedback ' + (ok ? 'is-ok' : 'is-no');
    fb.innerHTML = '<p class="iwi-trn-fb__verdict">' + icon(ok ? 'check' : 'x') + (ok ? ' Correct' : ' Not quite — the answer is “' + esc(q.options[q.answer]) + '”') + '</p>' +
      '<p class="iwi-trn-fb__why">' + esc(q.explain) + '</p>' + (q.source ? '<p class="iwi-trn-fb__src">Source: ' + srcLink(q.source) + '</p>' : '') +
      '<button type="button" class="iwi-trn-btn iwi-trn-btn--solid" data-trn-next>' + (last ? 'See my score' : 'Next question') + ' ' + icon('arrow') + '</button>';
    var dots = app.querySelectorAll('.iwi-trn-dots span'); if (dots[quiz.i]) dots[quiz.i].className = ok ? 'ok' : 'no';
    var cnt = app.querySelector('.iwi-trn-qcount'); if (cnt) cnt.textContent = 'Question ' + (quiz.i + 1) + ' of ' + quiz.qs.length + ' · score ' + quiz.score;
    var nb = fb.querySelector('[data-trn-next]');
    nb.addEventListener('click', next); nb.focus({ preventScroll: true });
    fb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
  function next() {
    if (!quiz) return;
    if (quiz.picks.length <= quiz.i) return;
    if (quiz.i < quiz.qs.length - 1) { quiz.i++; renderQ(); } else finish();
  }
  function finish() {
    var total = quiz.qs.length, p = pct(quiz.score, total);
    var passMark = quiz.kind === 'exam' ? D.pass_exam : D.pass_module, passed = p >= passMark, now = Date.now();
    if (quiz.kind === 'exam') {
      var e = ST.exam || { best: 0, attempts: 0, passed: false };
      e.attempts++; e.last = p; if (p > e.best) e.best = p; if (passed && !e.passed) { e.passed = true; e.ts = now; } if (passed && !e.ts) e.ts = now;
      ST.exam = e;
    } else {
      var r = ST.modules[quiz.m.id] || { best: 0, attempts: 0, passed: false };
      r.attempts++; r.last = p; if (p > r.best) r.best = p; if (passed) r.passed = true; r.ts = now;
      ST.modules[quiz.m.id] = r;
    }
    save(); updateHero();
    var nextMod = null;
    if (quiz.kind !== 'exam') { var list = mods(quiz.m.track); nextMod = list[list.indexOf(quiz.m) + 1] || null; }
    var review = quiz.qs.map(function (q, k) {
      var ok = quiz.picks[k] === q.answer;
      return '<li class="' + (ok ? 'ok' : 'no') + '"><p class="iwi-trn-rv__q">' + icon(ok ? 'check' : 'x') + ' ' + esc(q.q) + '</p>' +
        (ok ? '' : '<p class="iwi-trn-rv__a">Your answer: ' + esc(q.options[quiz.picks[k]]) + '</p>') +
        '<p class="iwi-trn-rv__a"><strong>Answer:</strong> ' + esc(q.options[q.answer]) + ' — ' + esc(q.explain) + '</p>' +
        (q.source ? '<p class="iwi-trn-rv__s">' + srcLink(q.source) + '</p>' : '') + '</li>';
    }).join('');
    var wrong = quiz.qs.length - quiz.score;
    app.innerHTML = '<div class="iwi-trn-quiz">' + quizHead() +
      '<div class="iwi-trn-result ' + (passed ? 'is-pass' : 'is-fail') + '">' +
      '<div class="iwi-trn-ring" style="--p:' + p + '"><span>' + p + '%</span></div>' +
      '<div><h2 class="iwi-trn-h2">' + (passed ? (quiz.kind === 'exam' ? 'Final exam passed' : 'Module passed') : 'Not yet — ' + passMark + '% to pass') + '</h2>' +
      '<p>' + quiz.score + ' of ' + total + ' correct' + (wrong ? ' · review the ' + wrong + ' you missed below' : ' · a perfect score') + '.</p>' +
      '<div class="iwi-trn-result__ctas"><button type="button" class="iwi-trn-btn" data-trn-retry>' + icon('retry') + ' Try again</button>' +
      (quiz.kind === 'exam' ? (eligible() ? '<a class="iwi-trn-btn iwi-trn-btn--solid" href="#/certificate">' + icon('star') + ' View certificate</a>' : '<a class="iwi-trn-btn iwi-trn-btn--solid" href="#/certificate">Certificate checklist</a>')
        : (nextMod ? '<a class="iwi-trn-btn iwi-trn-btn--solid" href="#/m/' + nextMod.id + '">Next: ' + esc(nextMod.title) + ' ' + icon('arrow') + '</a>' : '<a class="iwi-trn-btn iwi-trn-btn--solid" href="#/track/' + quiz.m.track + '">Back to the track</a>')) +
      '</div></div></div><h3 class="iwi-trn-h3">Review</h3><ol class="iwi-trn-review">' + review + '</ol></div>';
    var kind = quiz.kind, m = quiz.m;
    app.querySelector('[data-trn-retry]').addEventListener('click', function () { startQuiz(kind, m); });
    var h = app.querySelector('.iwi-trn-result .iwi-trn-h2'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }

  /* ---------- certificate ---------- */
  function viewCert() {
    var el = eligible(), c = core(), e = ST.exam;
    var extras = ['producers', 'selling'].map(function (t) { return passedCount(mods(t)) + ' of ' + mods(t).length + ' ' + trackOf(t).title.toLowerCase(); });
    var name = ST.name || '';
    var html = '<nav class="iwi-trn-crumbs"><a href="#/">' + icon('back') + ' All modules</a></nav>' +
      '<div class="iwi-trn-certwrap"><div class="iwi-trn-certtools"><div><h2 class="iwi-trn-h2">Certificate of completion</h2>' +
      (el ? '<p>Add your name as it should appear, then print or save as PDF.</p>' : '<p>Complete the checklist to unlock your certificate. Preview below.</p>') +
      '<ul class="iwi-trn-check"><li class="' + (passedCount(c) === c.length ? 'ok' : '') + '">' + icon(passedCount(c) === c.length ? 'check' : 'lock') + ' Foundations &amp; Italy modules passed: ' + passedCount(c) + '/' + c.length + '</li>' +
      '<li class="' + (e && e.passed ? 'ok' : '') + '">' + icon(e && e.passed ? 'check' : 'lock') + ' Final exam (' + D.pass_exam + '%): ' + (e ? 'best ' + e.best + '%' : 'not attempted') + '</li></ul></div>' +
      '<div class="iwi-trn-certform"><label>Name<input class="iwi-trn-input" type="text" maxlength="60" value="' + esc(name) + '" data-trn-name autocomplete="name"></label>' +
      '<label>Venue (optional)<input class="iwi-trn-input" type="text" maxlength="60" value="' + esc(ST.venue || '') + '" data-trn-venue></label>' +
      '<button type="button" class="iwi-trn-btn iwi-trn-btn--solid" data-trn-print' + (el ? '' : ' disabled') + '>' + icon('print') + ' Print / save PDF</button></div></div>' +
      '<div class="iwi-trn-cert' + (el ? '' : ' is-locked') + '" data-trn-cert><div class="iwi-trn-cert__band">' + (root.querySelector('.iwi-trn-hero__lock') ? root.querySelector('.iwi-trn-hero__lock').innerHTML : '') + '</div>' +
      '<div class="iwi-trn-cert__body"><p class="iwi-trn-cert__kicker">Certificate of completion</p>' +
      '<h3 class="iwi-trn-cert__title">IWI Staff Training — Level 1</h3><p class="iwi-trn-cert__pre">This certifies that</p>' +
      '<p class="iwi-trn-cert__name" data-trn-cname>' + esc(name || 'Your name') + '</p>' +
      '<p class="iwi-trn-cert__venue" data-trn-cvenue>' + esc(ST.venue || '') + '</p>' +
      '<p class="iwi-trn-cert__text">has completed the Italian Wine Importers staff programme: wine foundations (how wine is made, grown, tasted, paired and served) and Italy region by region, and passed the Level 1 final exam' + (e ? ' with ' + e.best + '%' : '') + '.</p>' +
      '<p class="iwi-trn-cert__extra">Also completed: ' + esc(extras.join(' · ')) + '</p>' +
      '<div class="iwi-trn-cert__foot"><div><span>Date</span><strong>' + esc(e && e.ts ? fmtDate(e.ts) : fmtDate(Date.now())) + '</strong></div>' +
      '<div><span>Issued by</span><strong>Italian Wine Importers · part of IF&amp;B Foodservice Australia</strong></div></div>' +
      (el ? '' : '<div class="iwi-trn-cert__lock">' + icon('lock') + ' Locked — finish the checklist</div>') + '</div></div></div>';
    app.innerHTML = html;
    var n = app.querySelector('[data-trn-name]'), v = app.querySelector('[data-trn-venue]');
    n.addEventListener('input', function () { ST.name = n.value; save(); app.querySelector('[data-trn-cname]').textContent = n.value || 'Your name'; });
    v.addEventListener('input', function () { ST.venue = v.value; save(); app.querySelector('[data-trn-cvenue]').textContent = v.value; });
    var pb = app.querySelector('[data-trn-print]');
    pb.addEventListener('click', function () { if (!eligible()) return; document.documentElement.classList.add('iwi-trn-printing'); window.print(); });
  }
  window.addEventListener('afterprint', function () { document.documentElement.classList.remove('iwi-trn-printing'); });

  /* ---------- router ---------- */
  function render() {
    if (!D) return;
    quiz = (location.hash.indexOf('/quiz') > -1 || location.hash === '#/exam') ? quiz : null;
    var h = (location.hash || '#/').replace(/^#/, '');
    var parts = h.split('/').filter(Boolean);
    updateHero();
    if (parts.length && parts[0] !== 'track' && parts[0] !== 'continue') {
      var top = app.getBoundingClientRect().top;
      if (top > window.innerHeight * 0.5 || top < -10) window.scrollTo({ top: top + window.pageYOffset - 80, behavior: 'smooth' });
    }
    if (parts[0] === 'm' && parts[1]) {
      if (parts[2] === 'quiz' && MOD[parts[1]]) return startQuiz('module', MOD[parts[1]]);
      return viewModule(parts[1]);
    }
    if (parts[0] === 'exam') return startQuiz('exam', null);
    if (parts[0] === 'certificate') return viewCert();
    if (parts[0] === 'track') return viewHome(parts[1]);
    if (parts[0] === 'continue') {
      var nextM = D.modules.filter(function (m) { return status(m) !== 'passed' && m.track !== 'producers'; })[0];
      location.replace('#/m/' + (nextM ? nextM.id : (ST.last || D.modules[0].id)));
      return;
    }
    viewHome();
  }
  document.addEventListener('keydown', function (ev) {
    if (!quiz || /input|textarea|select/i.test((ev.target && ev.target.tagName) || '')) return;
    var k = ev.key;
    if (/^[1-4]$/.test(k)) { var b = app.querySelector('.iwi-trn-opt[data-i="' + (+k - 1) + '"]'); if (b && !b.disabled) { ev.preventDefault(); b.click(); } }
    else if ((k === 'Enter' || k === 'ArrowRight') && quiz.picks.length > quiz.i && !(ev.target && ev.target.closest && ev.target.closest('button,a'))) { ev.preventDefault(); next(); }
  });
  window.addEventListener('hashchange', function () { render(); });

  /* ---------- boot ---------- */
  try {
    var pj = root.querySelector('[data-trn-producers]');
    JSON.parse(pj ? pj.textContent : '[]').forEach(function (p) { PRODS[p.h] = p; });
  } catch (e) {}
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  var urls = (root.getAttribute('data-src') || '').split('|').filter(Boolean);
  Promise.all(urls.map(function (u, k) { var p = getJSON(u); return k ? p.catch(function () { return { modules: [] }; }) : p; })).then(function (res) {
    var d = res[0]; res.slice(1).forEach(function (x) { d.modules = d.modules.concat(x.modules || []); });
    D = d; D.modules.forEach(function (m) { MOD[m.id] = m; });
    render();
  }).catch(function () {
    app.innerHTML = '<p class="iwi-trn-note">The course could not be loaded. Please refresh the page.</p>';
  });
})();
